/**
 * ---------------------------------------------------------------------------
 * Bellavista — modelkiezer in de header + case types gefilterd op telefoonmodel
 * ---------------------------------------------------------------------------
 * DEEL 1 — Modelkiezer in de menubalk
 *   1. Een knop "Choose your model" in de hoofdnavigatie (en een compacte
 *      variant naast het zoek-icoon op mobiel). Klikken opent een paneel met
 *      een zoekveld en alle modellen, gegroepeerd per merk.
 *   2. De keuze gaat in localStorage en blijft dus staan over pagina's en
 *      bezoeken heen. De knop toont daarna het gekozen model.
 *   3. Elke productpagina die daarna geopend wordt, heeft dat model meteen
 *      geselecteerd. Bestaat het model niet op dat design, dan blijft de
 *      pagina op "Choose your model" staan met een korte melding.
 *   4. Kiest iemand op de productpagina zelf een ander model, dan volgt de
 *      header mee.
 *
 * DEEL 2 — Case types gefilterd op model (ongewijzigd t.o.v. v3)
 *   1. Zolang er geen model gekozen is, blijven alle 4 de case types zichtbaar
 *      en staat Add to cart uit.
 *   2. Zodra er een model gekozen is, blijven enkel de case types staan die
 *      voor dat model bestaan.
 *   3. Stond er een case type aangeduid dat niet bestaat voor het nieuwe model,
 *      dan springt de selectie naar het eerste dat wel bestaat.
 *   4. De knop blijft uit zolang het verborgen id-veld nog naar de vorige
 *      variant wijst, zodat een snelle klik nooit het verkeerde model bestelt.
 *   5. Modellen zonder ook maar één variant verdwijnen uit de keuzelijst.
 *   6. Voor de modellen in PREORDER_MODELS zegt de knop "Pre-order" in plaats
 *      van "Add to cart". De labels New / Pre-order in het kiezerpaneel staan
 *      in assets/custom.css; die lijst moet mee bijgewerkt worden.
 *
 * Werkt op basis van de data-option-position attributen van het thema:
 * positie 1 = Model, positie 2 = Case type. Enkel producten met exact twee
 * opties worden aangeraakt, en de lege startstaat enkel als optie 1 "Model" heet.
 * Alles zit in dit ene bestand; geen liquid aangepast.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var TEXT_PLACEHOLDER = 'Choose your model';
  var TEXT_PICK_FIRST = 'Choose your model first';
  var TEXT_PANEL_TITLE = 'Choose your model';
  var TEXT_SEARCH = 'Search your phone…';
  var TEXT_NO_RESULTS = 'No model found. Try "17 pro" or "s25".';
  var TEXT_CLEAR = 'Clear';
  var TEXT_MOBILE = 'Model';
  var TEXT_PREORDER = 'Pre-order';

  // Modellen die nog niet uitgeleverd worden: daar zegt de koopknop
  // "Pre-order" in plaats van "Add to cart". De naam moet exact overeenkomen
  // met de modelwaarde in de winkel. Dezelfde modellen dragen het label
  // Pre-order in het kiezerpaneel (assets/custom.css) — hou beide gelijk.
  var PREORDER_MODELS = {
    'iPhone 18 Pro': true,
    'iPhone 18 Pro Max': true
  };

  var STORAGE_MODEL = 'bv-model';
  var STORAGE_LIST = 'bv-model-list';
  var LIST_TTL = 24 * 60 * 60 * 1000;
  // Product met de meeste modelwaarden; dient als bron om nieuw toegevoegde
  // modellen automatisch op te pikken zonder dit bestand aan te passen.
  var REFERENCE_PRODUCT = '/products/regalo-dinverno.js';

  var MODELS = [
      { brand: "Apple", models: [
        "iPhone 18 Pro Max",
        "iPhone 18 Pro",
        "iPhone 17 Pro Max",
        "iPhone 17 Pro",
        "iPhone 17 Air",
        "iPhone 17",
        "iPhone 17e",
        "iPhone 16 Pro Max",
        "iPhone 16 Pro",
        "iPhone 16 Plus",
        "iPhone 16",
        "iPhone 16e",
        "iPhone 15 Pro Max",
        "iPhone 15 Pro",
        "iPhone 15 Plus",
        "iPhone 15",
        "iPhone 14 Pro Max",
        "iPhone 14 Pro",
        "iPhone 14 Plus",
        "iPhone 14",
        "iPhone 13 Pro Max",
        "iPhone 13 Pro",
        "iPhone 13",
        "iPhone 13 Mini",
        "iPhone 12 Pro Max",
        "iPhone 12 Pro",
        "iPhone 12",
        "iPhone 12 Mini",
        "iPhone 11 Pro Max",
        "iPhone 11 Pro",
        "iPhone 11",
        "iPhone X / XS",
        "iPhone XR",
        "iPhone XS Max",
        "iPhone SE (2022)",
        "iPhone SE (2020)",
        "iPhone 7 / 8",
        "iPhone 7 Plus / 8 Plus"
      ] },
      { brand: "Samsung", models: [
        "Samsung Galaxy S26 Ultra",
        "Samsung Galaxy S26 Plus",
        "Samsung Galaxy S26",
        "Samsung Galaxy S25 Ultra",
        "Samsung Galaxy S25 Edge",
        "Samsung Galaxy S25 Plus",
        "Samsung Galaxy S25",
        "Samsung Galaxy S25 Fe",
        "Samsung Galaxy S24 Ultra",
        "Samsung Galaxy S24 Plus",
        "Samsung Galaxy S24",
        "Samsung Galaxy S24 Fe",
        "Samsung Galaxy S23 Ultra 5G",
        "Samsung Galaxy S23 Plus 5G",
        "Samsung Galaxy S23 5G",
        "Samsung Galaxy S23 Fe",
        "Samsung Galaxy S22 Ultra 5G",
        "Samsung Galaxy S22 Plus 5G",
        "Samsung Galaxy S22 5G",
        "Samsung Galaxy S21 Ultra",
        "Samsung Galaxy S21 Plus",
        "Samsung Galaxy S21",
        "Samsung Galaxy S21 Fe",
        "Samsung Galaxy S20 Ultra",
        "Samsung Galaxy S20 Plus",
        "Samsung Galaxy S20",
        "Samsung Galaxy S20 Fe",
        "Samsung Galaxy S10 Plus",
        "Samsung Galaxy S10",
        "Samsung Galaxy S10 Lite",
        "Samsung Galaxy S10e",
        "Samsung Galaxy S8",
        "Samsung Galaxy Z Flip 7",
        "Samsung Galaxy Z Flip 6 / 7 FE",
        "Samsung Galaxy Z Flip 5",
        "Samsung Galaxy Z Flip 4",
        "Samsung Galaxy Z Fold 4",
        "Samsung Galaxy Z Flip 3",
        "Samsung Galaxy Z Fold 3 5G",
        "Samsung Galaxy Note 20 Ultra",
        "Samsung Galaxy Note 20 Ultra 5G",
        "Samsung Galaxy Note 20",
        "Samsung Galaxy Note 20 5G",
        "Samsung Galaxy Note 10 Plus",
        "Samsung Galaxy Note 10",
        "Samsung Galaxy Note 9",
        "Samsung Galaxy A73",
        "Samsung Galaxy A72",
        "Samsung Galaxy A72 4G / 5G",
        "Samsung Galaxy A71",
        "Samsung Galaxy A57",
        "Samsung Galaxy A56",
        "Samsung Galaxy A55",
        "Samsung Galaxy A54 5G",
        "Samsung Galaxy A53",
        "Samsung Galaxy A52 / A52S",
        "Samsung Galaxy A51",
        "Samsung Galaxy A51 5G",
        "Samsung Galaxy A50",
        "Samsung Galaxy A37",
        "Samsung Galaxy A36",
        "Samsung Galaxy A35",
        "Samsung Galaxy A34",
        "Samsung Galaxy A33 5G",
        "Samsung Galaxy A32 5G",
        "Samsung Galaxy A26",
        "Samsung Galaxy A25",
        "Samsung Galaxy A23 4G /5G",
        "Samsung Galaxy A22 5G",
        "Samsung Galaxy A17",
        "Samsung Galaxy A16",
        "Samsung Galaxy A15 4G /5G",
        "Samsung Galaxy A14 5G",
        "Samsung Galaxy A13",
        "Samsung Galaxy A12"
      ] },
      { brand: "Google", models: [
        "Google Pixel 10 Pro XL",
        "Google Pixel 10 / 10 Pro",
        "Google Pixel 10A",
        "Google Pixel 9 Pro XL",
        "Google Pixel 9 / 9 Pro",
        "Google Pixel 9A",
        "Google Pixel 8 Pro",
        "Google Pixel 8",
        "Google Pixel 8A",
        "Google Pixel 7 Pro",
        "Google Pixel 7",
        "Google Pixel 7A",
        "Google Pixel 6 Pro",
        "Google Pixel 6",
        "Google Pixel 6A",
        "Google Pixel 5"
      ] },
      { brand: "Xiaomi", models: [
        "Xiaomi 15 Ultra",
        "Xiaomi 15 Pro",
        "Xiaomi 15T Pro",
        "Xiaomi 15",
        "Xiaomi 15T",
        "Xiaomi 14 Ultra",
        "Xiaomi 14 Pro",
        "Xiaomi 14T Pro",
        "Xiaomi 14",
        "Xiaomi 14T",
        "Xiaomi 13 Pro",
        "Xiaomi 13T / 13T Pro",
        "Xiaomi 13",
        "Xiaomi 13 Lite",
        "Xiaomi 12 Pro",
        "Xiaomi 12T / 12T Pro",
        "Xiaomi 12",
        "Xiaomi 11T / 11T Pro",
        "Xiaomi 11 Lite 5G NE",
        "Xiaomi Redmi Note 14 Pro+ 5G",
        "Xiaomi Redmi Note 14 Pro 5G",
        "Xiaomi Redmi Note 14 5G",
        "Xiaomi Redmi Note 13 Pro+ 5G",
        "Xiaomi Redmi Note 13 Pro 5G",
        "Xiaomi Redmi Note 13 5G",
        "Xiaomi Redmi Note 12 Pro+ 5G",
        "Xiaomi Redmi Note 12 Pro 5G",
        "Xiaomi Redmi Note 11 Pro+",
        "Xiaomi Redmi Note 11T Pro / Pro+",
        "Xiaomi Redmi Note 11 Pro",
        "Xiaomi Redmi Note 10 Pro",
        "Xiaomi MI 11 Lite 4G/5G"
      ] },
      { brand: "OnePlus", models: [
        "Oneplus 13",
        "Oneplus 12",
        "Oneplus 11",
        "Oneplus 10 Pro 5G",
        "Oneplus 9 Pro",
        "Oneplus 9",
        "Oneplus 8",
        "Oneplus Ace Pro"
      ] },
      { brand: "Huawei", models: [
        "Huawei P40 Pro Plus",
        "Huawei P40",
        "Huawei P30 Pro",
        "Huawei P30",
        "Huawei P30 Lite"
      ] },
      { brand: "Motorola", models: [
        "Motorola Moto G Power 2021"
      ] }
    ];

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function pairKey(model, caseType) {
    return String(model) + ' || ' + String(caseType);
  }

  function normalize(value) {
    return String(value).toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  /* =========================================================================
   * Opslag van het gekozen model
   * ========================================================================= */

  function readModel() {
    try {
      return window.localStorage.getItem(STORAGE_MODEL) || '';
    } catch (error) {
      return '';
    }
  }

  function writeModel(value) {
    try {
      if (value) {
        window.localStorage.setItem(STORAGE_MODEL, value);
      } else {
        window.localStorage.removeItem(STORAGE_MODEL);
      }
    } catch (error) {
      /* privémodus: dan onthouden we het gewoon niet */
    }
    document.dispatchEvent(new CustomEvent('bv:model', { detail: { model: value } }));
  }

  /* =========================================================================
   * Modellijst — ingebouwde lijst, aangevuld met wat de winkel intussen
   * bijgekregen heeft (één keer per dag opgehaald bij het referentieproduct).
   * ========================================================================= */

  function brandOf(model) {
    if (/^iphone/i.test(model)) return 'Apple';
    if (/^samsung/i.test(model)) return 'Samsung';
    if (/^google/i.test(model)) return 'Google';
    if (/^xiaomi/i.test(model) || /^redmi/i.test(model)) return 'Xiaomi';
    if (/^oneplus/i.test(model)) return 'OnePlus';
    if (/^huawei/i.test(model)) return 'Huawei';
    if (/^motorola/i.test(model) || /^moto /i.test(model)) return 'Motorola';
    if (/^oppo/i.test(model)) return 'Oppo';
    if (/^nothing/i.test(model)) return 'Nothing';
    return 'Other';
  }

  function knownModels() {
    var seen = {};
    MODELS.forEach(function (group) {
      group.models.forEach(function (model) {
        seen[model] = true;
      });
    });
    return seen;
  }

  function mergeModels(extra) {
    var seen = knownModels();
    var byBrand = {};
    MODELS.forEach(function (group) {
      byBrand[group.brand] = group;
    });

    var added = false;
    extra.forEach(function (model) {
      if (seen[model]) return;
      seen[model] = true;
      added = true;
      var brand = brandOf(model);
      if (!byBrand[brand]) {
        byBrand[brand] = { brand: brand, models: [] };
        MODELS.push(byBrand[brand]);
      }
      // Nieuwe modellen zijn zo goed als altijd de nieuwste: bovenaan.
      byBrand[brand].models.unshift(model);
    });
    return added;
  }

  function refreshModelList(onChange) {
    var cached = null;
    try {
      cached = JSON.parse(window.localStorage.getItem(STORAGE_LIST) || 'null');
    } catch (error) {
      cached = null;
    }

    if (cached && cached.models && cached.at && Date.now() - cached.at < LIST_TTL) {
      if (mergeModels(cached.models)) onChange();
      return;
    }

    if (!window.fetch) return;

    window.fetch(REFERENCE_PRODUCT, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (product) {
        if (!product || !product.variants || !product.variants.length) return;
        // Enkel modellen die écht een variant hebben — geen dode restanten.
        var alive = {};
        product.variants.forEach(function (variant) {
          if (variant.option1) alive[variant.option1] = true;
        });
        var models = Object.keys(alive);
        try {
          window.localStorage.setItem(STORAGE_LIST, JSON.stringify({ at: Date.now(), models: models }));
        } catch (error) {
          /* niets aan te doen */
        }
        if (mergeModels(models)) onChange();
      })
      .catch(function () {
        /* offline of geblokkeerd: de ingebouwde lijst volstaat */
      });
  }

  /* =========================================================================
   * DEEL 1 — De kiezer in de header
   * ========================================================================= */

  var STYLES = [
    '.bv-pick{display:flex;align-items:center;gap:.4em;background:none;border:0;padding:0;margin:0;',
    'font:inherit;color:inherit;cursor:pointer;text-align:left;}',
    '.bv-pick__label{border-bottom:1px solid currentColor;padding-bottom:1px;}',
    '.bv-pick svg{width:.7em;height:.7em;flex:none;}',
    '.bv-slot{display:flex;align-items:center;margin-right:18px;}',
    '.bv-pick--compact{font-size:12px;max-width:7em;min-width:0;flex:0 1 auto;margin-right:10px;}',
    '.bv-pick--compact .bv-pick__label{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}',
    '@media (max-width:380px){.bv-pick--compact{max-width:5em;margin-right:6px;}}',
    '.bv-modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:100;display:flex;align-items:center;justify-content:center;padding:16px;}',
    '.bv-modal[hidden]{display:none;}',
    '.bv-modal__veil{position:absolute;top:0;right:0;bottom:0;left:0;background:rgba(0,0,0,.45);}',
    '.bv-modal__sheet{position:relative;display:flex;flex-direction:column;width:100%;max-width:520px;',
    'max-height:min(78vh,640px);background:#fff;color:#1a1a1a;border-radius:8px;overflow:hidden;',
    'box-shadow:0 18px 50px rgba(0,0,0,.28);}',
    '.bv-modal__head{display:flex;align-items:center;gap:12px;padding:18px 20px 12px;}',
    '.bv-modal__title{margin:0;font-size:17px;font-weight:600;flex:1;}',
    '.bv-modal__close{background:none;border:0;font-size:24px;line-height:1;cursor:pointer;padding:0 4px;color:inherit;}',
    '.bv-modal__search{margin:0 20px 12px;padding:11px 13px;width:calc(100% - 40px);box-sizing:border-box;',
    'border:1px solid #d5d5d5;border-radius:6px;font:inherit;font-size:15px;background:#fff;color:inherit;}',
    '.bv-modal__search:focus{outline:2px solid #1a1a1a;outline-offset:-1px;}',
    '.bv-modal__list{overflow-y:auto;padding:0 8px 8px;flex:1;-webkit-overflow-scrolling:touch;}',
    '.bv-modal__brand{padding:14px 12px 6px;font-size:11px;letter-spacing:.09em;text-transform:uppercase;opacity:.55;}',
    '.bv-modal__item{display:block;width:100%;text-align:left;background:none;border:0;padding:10px 12px;',
    'font:inherit;font-size:15px;line-height:1.35;color:inherit;cursor:pointer;border-radius:5px;}',
    '.bv-modal__item:hover,.bv-modal__item:focus{background:#f1f1f1;outline:none;}',
    '.bv-modal__item[aria-current="true"]{background:#1a1a1a;color:#fff;}',
    '.bv-modal__empty{padding:24px 12px;opacity:.6;font-size:14px;}',
    '.bv-modal__foot{padding:10px 20px 16px;}',
    '.bv-modal__clear{background:none;border:0;padding:0;font:inherit;font-size:14px;cursor:pointer;',
    'text-decoration:underline;color:inherit;opacity:.7;}',
    '.bv-note{margin:8px 0 0;font-size:13px;line-height:1.4;opacity:.75;}',
    '@media (max-width:640px){.bv-modal{padding:0;}.bv-modal__sheet{max-width:none;max-height:100%;height:100%;border-radius:0;}}'
  ].join('');

  var CARET = '<svg viewBox="0 0 10 6" aria-hidden="true" focusable="false"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>';

  var modal = null;
  var listBox = null;
  var searchBox = null;
  var lastFocus = null;

  function labelFor() {
    return readModel() || TEXT_PLACEHOLDER;
  }

  function buildModal() {
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'bv-modal';
    modal.setAttribute('hidden', 'hidden');
    modal.innerHTML =
      '<div class="bv-modal__veil" data-bv-close></div>' +
      '<div class="bv-modal__sheet" role="dialog" aria-modal="true" aria-label="' + TEXT_PANEL_TITLE + '">' +
        '<div class="bv-modal__head">' +
          '<h2 class="bv-modal__title">' + TEXT_PANEL_TITLE + '</h2>' +
          '<button type="button" class="bv-modal__close" data-bv-close aria-label="Close">&times;</button>' +
        '</div>' +
        '<input type="search" class="bv-modal__search" placeholder="' + TEXT_SEARCH + '" autocomplete="off" ' +
          'autocorrect="off" spellcheck="false">' +
        '<div class="bv-modal__list"></div>' +
        '<div class="bv-modal__foot"><button type="button" class="bv-modal__clear">' + TEXT_CLEAR + '</button></div>' +
      '</div>';

    document.body.appendChild(modal);
    listBox = modal.querySelector('.bv-modal__list');
    searchBox = modal.querySelector('.bv-modal__search');

    modal.addEventListener('click', function (event) {
      if (event.target.hasAttribute && event.target.hasAttribute('data-bv-close')) closeModal();
    });

    modal.querySelector('.bv-modal__clear').addEventListener('click', function () {
      writeModel('');
      closeModal();
    });

    searchBox.addEventListener('input', function () {
      renderList(searchBox.value);
    });

    searchBox.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      var first = listBox.querySelector('.bv-modal__item');
      if (first) first.click();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hasAttribute('hidden')) closeModal();
    });

    listBox.addEventListener('click', function (event) {
      var button = event.target.closest ? event.target.closest('.bv-modal__item') : null;
      if (!button) return;
      writeModel(button.getAttribute('data-model'));
      closeModal();
      applyStoredModelEverywhere();
    });

    return modal;
  }

  function renderList(query) {
    if (!listBox) return;

    var needle = normalize(query || '');
    var current = readModel();
    var html = '';
    var hits = 0;

    MODELS.forEach(function (group) {
      var matches = group.models.filter(function (model) {
        return !needle || normalize(model).indexOf(needle) > -1 || normalize(group.brand).indexOf(needle) > -1;
      });
      if (!matches.length) return;
      hits += matches.length;
      html += '<div class="bv-modal__brand">' + group.brand + '</div>';
      matches.forEach(function (model) {
        html += '<button type="button" class="bv-modal__item" data-model="' + model.replace(/"/g, '&quot;') + '"' +
          (model === current ? ' aria-current="true"' : '') + '>' + model + '</button>';
      });
    });

    listBox.innerHTML = hits ? html : '<p class="bv-modal__empty">' + TEXT_NO_RESULTS + '</p>';
  }

  function openModal() {
    buildModal();
    lastFocus = document.activeElement;
    modal.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
    searchBox.value = '';
    renderList('');
    var active = listBox.querySelector('[aria-current="true"]');
    if (active) active.scrollIntoView({ block: 'center' });
    setTimeout(function () {
      searchBox.focus();
    }, 30);
  }

  function closeModal() {
    if (!modal) return;
    modal.setAttribute('hidden', 'hidden');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function makeTrigger(compact, extraClass) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'bv-pick' + (compact ? ' bv-pick--compact' : '') + (extraClass ? ' ' + extraClass : '');
    button.setAttribute('data-bv-trigger', compact ? 'compact' : 'full');
    button.innerHTML = '<span class="bv-pick__label"></span>' + CARET;
    button.addEventListener('click', openModal);
    return button;
  }

  function paintTriggers() {
    var model = readModel();
    toArray(document.querySelectorAll('[data-bv-trigger]')).forEach(function (button) {
      var compact = button.getAttribute('data-bv-trigger') === 'compact';
      var label = button.querySelector('.bv-pick__label');
      var text = model || (compact ? TEXT_MOBILE : TEXT_PLACEHOLDER);
      // Alleen schrijven als het echt verandert — anders blijft de
      // MutationObserver zichzelf om de 200 ms opnieuw wakker maken.
      if (label.textContent !== text) label.textContent = text;
      var aria = model ? TEXT_PANEL_TITLE + ' (' + model + ')' : TEXT_PANEL_TITLE;
      if (button.getAttribute('aria-label') !== aria) button.setAttribute('aria-label', aria);
    });
  }

  function ensureTriggers() {
    // Desktop: rechts in de menubalk, vóór de valuta- en taalkiezer. Niet in
    // het hoofdmenu zelf — dat is te smal en zou naar een tweede regel springen
    // zodra er een lange modelnaam in staat.
    var bar = document.querySelector('.Header__SecondaryMenu');
    if (bar && !bar.querySelector('[data-bv-trigger="full"]')) {
      var slot = document.createElement('div');
      slot.className = 'bv-slot HiddenMediumDown';
      slot.appendChild(makeTrigger(false, 'TitleMedium'));
      bar.insertBefore(slot, bar.firstChild);
    }

    // Mobiel: compacte knop links van het zoek-icoon.
    var iconNav = document.querySelector('.Header__SecondaryMenu .Nav');
    if (iconNav && !iconNav.querySelector('[data-bv-trigger]')) {
      var mobileItem = document.createElement('li');
      mobileItem.className = 'Nav__Item HiddenLarge';
      mobileItem.appendChild(makeTrigger(true));
      iconNav.insertBefore(mobileItem, iconNav.firstChild);
    }

    paintTriggers();
  }

  function injectStyles() {
    if (document.getElementById('bv-styles')) return;
    var style = document.createElement('style');
    style.id = 'bv-styles';
    style.textContent = STYLES;
    document.head.appendChild(style);
  }

  /* =========================================================================
   * DEEL 2 — De productpagina
   * ========================================================================= */

  var pickers = [];

  function applyStoredModelEverywhere() {
    pickers.forEach(function (picker) {
      picker.applyStored(true);
    });
  }

  // Het thema zet geen optienamen in de product-JSON, dus het aantal opties
  // komt uit de varianten zelf.
  function optionCount(product) {
    var variant = product.variants[0] || {};
    if (variant.options && variant.options.length) return variant.options.length;
    if (variant.option3 != null) return 3;
    if (variant.option2 != null) return 2;
    return 1;
  }

  function rootFor(jsonElement) {
    var node = jsonElement.parentElement;
    while (node && node !== document.body) {
      if (node.querySelector('.Product__Block--variantPicker')) return node;
      node = node.parentElement;
    }
    return null;
  }

  function Picker(root, product) {
    this.root = root;
    this.product = product;
    this.map = {};
    this.pairs = {};
    this.pending = null;
    this.retries = 0;
    this.placeholderDone = false;
    this.storedDone = false;

    var map = this.map;
    var pairs = this.pairs;
    product.variants.forEach(function (variant) {
      var model = variant.option1;
      if (!map[model]) map[model] = [];
      if (map[model].indexOf(variant.option2) === -1) map[model].push(variant.option2);
      pairs[pairKey(model, variant.option2)] = {
        id: String(variant.id),
        available: variant.available !== false
      };
    });

    this.isModelProduct = this.firstOptionName().toLowerCase() === 'model';

    var price = root.querySelector('.Product__PriceList');
    this.priceHTML = price ? price.innerHTML : null;

    this.init();
  }

  Picker.prototype.block = function () {
    return this.root.querySelector('.Product__Block--variantPicker') || this.root;
  };

  Picker.prototype.modelSelect = function () {
    var option = this.root.querySelector('option[data-option-position="1"]');
    return option ? option.closest('select') : null;
  };

  Picker.prototype.caseSelect = function () {
    var option = this.root.querySelector('option[data-option-position="2"]');
    return option ? option.closest('select') : null;
  };

  Picker.prototype.caseRadios = function () {
    return toArray(this.root.querySelectorAll('input[type="radio"][data-option-position="2"]'));
  };

  // Naam van optie 1, uit de naam van het veld of anders uit het label ernaast.
  Picker.prototype.firstOptionName = function () {
    var select = this.modelSelect();
    var control = select || this.root.querySelector('input[type="radio"][data-option-position="1"]');
    if (!control) return '';

    var match = /\[([^\]]+)\]/.exec(control.name || '');
    if (match) return match[1].trim();

    var wrapper = control.closest('.ProductForm__Option');
    var label = wrapper && wrapper.querySelector('.ProductForm__Label, label');
    return label ? label.textContent.split(':')[0].trim() : '';
  };

  Picker.prototype.modelValue = function () {
    var select = this.modelSelect();
    if (select) return select.value;
    var checked = this.root.querySelector('input[type="radio"][data-option-position="1"]:checked');
    return checked ? checked.value : '';
  };

  Picker.prototype.caseValue = function () {
    var checked = this.root.querySelector('input[type="radio"][data-option-position="2"]:checked');
    if (checked) return checked.value;
    var select = this.caseSelect();
    return select ? select.value : '';
  };

  Picker.prototype.init = function () {
    var self = this;

    this.root.addEventListener('change', function (event) {
      // Kiest de klant hier een model, dan volgt de header mee.
      var target = event.target;
      if (self.isModelProduct && target && target.getAttribute) {
        var isModelControl = target === self.modelSelect() ||
          target.getAttribute('data-option-position') === '1';
        if (isModelControl && target.value && target.value !== readModel()) {
          writeModel(target.value);
        }
      }
      self.schedule();
    }, false);

    // Het thema herrendert het hele variant-picker blok na elke wijziging,
    // dus na zo'n vervanging moet het filter opnieuw toegepast worden.
    new MutationObserver(function () {
      self.schedule();
    }).observe(this.block(), { childList: true, subtree: true });

    this.pruneDeadModels();
    this.addPlaceholder();
    this.applyStored(false);
    this.apply();
  };

  Picker.prototype.schedule = function (delay) {
    var self = this;
    if (this.pending) return;
    this.pending = setTimeout(function () {
      self.pending = null;
      self.pruneDeadModels();
      self.apply();
    }, delay || 0);
  };

  // Modelwaarden zonder ook maar één variant (restanten van verwijderde
  // varianten) horen niet in de keuzelijst thuis.
  Picker.prototype.pruneDeadModels = function () {
    if (!this.isModelProduct) return;
    var select = this.modelSelect();
    if (!select) return;
    var map = this.map;
    toArray(select.options).forEach(function (option) {
      if (option.hasAttribute('data-bv-placeholder')) return;
      if (option.value === '') return;
      if (!map[option.value]) option.remove();
    });
  };

  Picker.prototype.addPlaceholder = function () {
    if (!this.isModelProduct || this.placeholderDone) return;

    var select = this.modelSelect();
    if (!select) return;

    this.placeholderDone = true;

    // Deel-link naar een specifieke variant: die keuze respecteren.
    if (window.location.search.indexOf('variant=') > -1) return;
    if (select.querySelector('option[data-bv-placeholder]')) return;

    var option = document.createElement('option');
    option.value = '';
    option.textContent = TEXT_PLACEHOLDER;
    option.setAttribute('data-option-position', '1');
    option.setAttribute('data-bv-placeholder', '');
    select.insertBefore(option, select.firstChild);
    select.value = '';
    select.dispatchEvent(new Event('change', { bubbles: true }));
  };

  Picker.prototype.note = function (text) {
    var block = this.block();
    var note = block.querySelector('.bv-note');
    if (!text) {
      if (note) note.remove();
      return;
    }
    if (!note) {
      note = document.createElement('p');
      note.className = 'bv-note';
      // Vlak onder de modelkiezer, niet onderaan het blok.
      var select = this.modelSelect();
      var wrapper = select && select.closest('.ProductForm__Option');
      if (wrapper && wrapper.parentElement) {
        wrapper.parentElement.insertBefore(note, wrapper.nextSibling);
      } else {
        block.appendChild(note);
      }
    }
    if (note.textContent !== text) note.textContent = text;
  };

  // Het model uit de header op deze pagina toepassen.
  Picker.prototype.applyStored = function (force) {
    if (!this.isModelProduct) return;
    if (!force && this.storedDone) return;
    if (!force && window.location.search.indexOf('variant=') > -1) return;

    this.storedDone = true;

    var stored = readModel();
    if (!stored) {
      this.note('');
      return;
    }

    if (!this.map[stored]) {
      this.note('This design is not available for the ' + stored + ' yet — pick another model below.');
      return;
    }

    this.note('');

    var select = this.modelSelect();
    if (select && select.value !== stored) {
      var exists = toArray(select.options).some(function (option) {
        return option.value === stored;
      });
      if (exists) {
        select.value = stored;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }

    var radio = this.root.querySelector('input[type="radio"][data-option-position="1"][value="' +
      stored.replace(/"/g, '\\"') + '"]');
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  Picker.prototype.apply = function () {
    var model = this.modelValue();
    var allowed = model ? this.map[model] : null;

    var radios = this.caseRadios();
    var caseSelect = this.caseSelect();

    if (radios.length) {
      var firstRadio = null;
      var switchRadio = false;

      radios.forEach(function (input) {
        var wrapper = input.closest('li') || input.parentElement;
        var ok = !allowed || allowed.indexOf(input.value) > -1;
        if (wrapper) {
          var display = ok ? '' : 'none';
          if (wrapper.style.display !== display) wrapper.style.display = display;
        }
        if (ok && !firstRadio) firstRadio = input;
        if (!ok && input.checked) switchRadio = true;
      });

      if (switchRadio && firstRadio) {
        firstRadio.checked = true;
        firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else if (caseSelect) {
      var firstOption = null;
      var switchOption = false;

      toArray(caseSelect.options).forEach(function (option) {
        var ok = !allowed || allowed.indexOf(option.value) > -1;
        option.hidden = !ok;
        option.disabled = !ok;
        if (ok && !firstOption) firstOption = option;
        if (!ok && option.selected) switchOption = true;
      });

      if (switchOption && firstOption) {
        caseSelect.value = firstOption.value;
        caseSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    this.updateBuyState(model);
  };

  Picker.prototype.setButton = function (button, enabled, label) {
    if (!button) return;
    if (enabled) {
      button.removeAttribute('disabled');
      button.setAttribute('data-action', 'add-to-cart');
    } else {
      button.setAttribute('disabled', 'disabled');
      button.removeAttribute('data-action');
    }
    if (label && button.textContent.trim() !== label) {
      button.innerHTML = '<span>' + label + '</span>';
    }
  };

  // Tekst op de koopknop: "Pre-order" voor de modellen die nog niet
  // uitgeleverd worden, anders de gewone tekst van het thema.
  Picker.prototype.buyLabel = function (model) {
    if (PREORDER_MODELS[model]) return TEXT_PREORDER;
    return (window.languages && window.languages.productFormAddToCart) || 'Add to cart';
  };

  Picker.prototype.updateBuyState = function (model) {
    var button = this.root.querySelector('.ProductForm__AddToCart');
    var dynamic = this.root.querySelector('.shopify-payment-button');
    var price = this.root.querySelector('.Product__PriceList');
    var idSelect = this.root.querySelector('select[name="id"]');

    var empty = this.isModelProduct && model === '';
    this.root.setAttribute('data-bv-model-empty', empty ? 'true' : 'false');
    this.root.setAttribute('data-bv-preorder', PREORDER_MODELS[model] ? 'true' : 'false');

    if (empty) {
      // Zelf blokkeren, los van wat het thema denkt: zonder model geen bestelling.
      this.setButton(button, false, TEXT_PICK_FIRST);
      if (dynamic) dynamic.style.display = 'none';
      // Het thema wist de prijs zodra er geen variant is; die zetten we terug.
      if (price && this.priceHTML && !price.innerHTML.trim()) price.innerHTML = this.priceHTML;
      return;
    }

    var pair = this.pairs[pairKey(model, this.caseValue())];
    // Combinatie bestaat niet: het thema zet de knop zelf op "Unavailable".
    if (!pair || !idSelect) return;

    // Het verborgen veld `id` — dat is wat er écht in de winkelwagen belandt — wordt pas
    // bijgewerkt als het thema de sectie opnieuw opgehaald heeft, ruwweg anderhalve
    // seconde later. Tot dan wijst het naar de vórige variant, dus zolang blijft de knop
    // uit. Anders koopt een snelle klant het model dat hij net weggeklikt heeft.
    if (String(idSelect.value) !== pair.id) {
      this.setButton(button, false, null);
      if (dynamic) dynamic.style.display = 'none';
      if (this.retries < 60) {
        this.retries++;
        this.schedule(250);
      }
      return;
    }

    this.retries = 0;

    if (pair.available) {
      this.setButton(button, true, this.buyLabel(model));
      if (dynamic) dynamic.style.display = '';
    }
  };

  /* =========================================================================
   * Opstarten
   * ========================================================================= */

  function scan() {
    toArray(document.querySelectorAll('[data-product-json]')).forEach(function (jsonElement) {
      if (jsonElement.getAttribute('data-bv-filter')) return;

      var data;
      try {
        data = JSON.parse(jsonElement.innerHTML);
      } catch (error) {
        jsonElement.setAttribute('data-bv-filter', 'skip');
        return;
      }

      var product = data && data.product;
      var root = rootFor(jsonElement);

      jsonElement.setAttribute('data-bv-filter', '1');

      if (!root) return;
      if (!product || !product.id || !product.variants || !product.variants.length) return;
      if (optionCount(product) !== 2) return;

      pickers.push(new Picker(root, product));
    });
  }

  var rescan = null;
  function scheduleScan() {
    if (rescan) return;
    rescan = setTimeout(function () {
      rescan = null;
      ensureTriggers();
      scan();
    }, 200);
  }

  function start() {
    injectStyles();
    ensureTriggers();
    scan();

    document.addEventListener('bv:model', function () {
      paintTriggers();
      if (modal && !modal.hasAttribute('hidden')) renderList(searchBox.value);
    });

    // Een andere tab kan het model ook wijzigen.
    window.addEventListener('storage', function (event) {
      if (event.key === STORAGE_MODEL) paintTriggers();
    });

    refreshModelList(function () {
      if (modal && !modal.hasAttribute('hidden')) renderList(searchBox.value);
    });

    // Quickview en het theme-editor herladen secties dynamisch.
    new MutationObserver(scheduleScan).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', scheduleScan);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
